import { SIM_BUILDER_API_END_POINT } from "../Config";
import RequestService, { HttpMethods } from "../utils/requestService";
import authFetch from "../utils/authFetch";

const SimResultService = () => {
  return Object.freeze({
    saveSimResult: async (simResult) => {
      const options = RequestService.makeRequest(HttpMethods.POST);
      options["body"] = JSON.stringify(simResult);

      const result = await authFetch(
        SIM_BUILDER_API_END_POINT + "/simResult/save",
        options
      );
      const response = await result.json();

      return response;
    },
    getVideoTranscript: async (key) => {
      const options = RequestService.makeRequest("GET" );
      const result = await authFetch(
        SIM_BUILDER_API_END_POINT + "/recordedTrack/getTranscript/" + key,
        options
      );
      const response = await result.json();
      return response;
    },
  });
};

export default SimResultService;
